import { createSlice } from '@reduxjs/toolkit';

export interface ImportVendorsModalState {
    isOpen: boolean;
}

const initialState: ImportVendorsModalState = {
    isOpen: false,
};

export const importVendorsModalSlice = createSlice({
    name: 'import-vendors-modal',
    initialState,
    reducers: {
        open(state: ImportVendorsModalState) {
            // eslint-disable-next-line no-param-reassign
            state.isOpen = true;
        },
        close(state: ImportVendorsModalState) {
            // eslint-disable-next-line no-param-reassign
            state.isOpen = false;
        },
    },
});

